
import { hostImg } from "../../callApi/AxiosCall";
import { getProductApi } from "../../callApi/productApi";
import CustomBottom from "../../components/CustomBottom";
import CustomHeader from "../../components/CustomHeader";
import CustomInput from "../../components/CustomInput";
import CustomPagination from "../../components/CustomPagination";
import Notiflix from "notiflix";
import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import CustomButton from "../../components/CustomButton";
import CustomInputProduct from "../../components/CustomInputProduct";
import { DashboardNoTokenApi } from "../../callApi/dashboard";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useNavigate } from "react-router-dom";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function CircularDesign() {
  const [searchValue, setsearchValue] = useState("");
  const [nowPage, setnowPage] = useState(1);
  const [allPage, setallPage] = useState(1);
  const [productItem, setproductItem] = useState(null);
  const [ProductCircular, setProductCircular] = useState(null);
  const [series, setseries] = useState(null);
  const [series2, setseries2] = useState(null);
  const [year, setyear] = useState({
    name: "ทั้งหมด",
    value: { start_date: "", end_date: "" },
  });
  const typeYear = [
    {
      name: "ทั้งหมด",
      value: { start_date: "", end_date: "" },
    },
    {
      name: "2024",
      value: { start_date: "2024-01-01", end_date: "2024-12-31" },
    },
    {
      name: "2023",
      value: { start_date: "2023-01-01", end_date: "2023-12-31" },
    },
  ];
  const router = useNavigate();

  useEffect(() => {
    callproduct();
  }, [nowPage, year]);
  const callproduct = async () => {
    Notiflix.Loading.circle();
    let res = await getProductApi({
      page: nowPage,
      limit: 8,
      search: searchValue,
      end_date: year?.value?.end_date ?? "",
      start_date: year?.value?.start_date ?? "",
    });
    Notiflix.Loading.remove();
    if (res?.status == 200) {
      setsearchValue("");
      setproductItem(res.data.data.products);
      setallPage(Math.ceil(res?.data?.data?.count / 8));
      setProductCircular(res.data.data);
    }
  };

  
  useEffect(() => {
    callData();
  }, [ year]);
  const callData = async () => {
    let res = await DashboardNoTokenApi({
      end_date: year?.value?.end_date ?? "",
      start_date: year?.value?.start_date ?? "",
    });
    if (res.status == 200) {
      let temp = [...res.data.data];
      let tempDataset = {
        labels: [],
        datasets: [
          {
            label: "จำนวน",
            data: [],
            backgroundColor: ["#20ac65aa", "#f7bf07aa", "#d3893faa"],
            borderColor: ["#32593e", "#ce8a4c", "#8b5e3f"],
            borderWidth: 1,
          },
        ],
      };
      let tempDataset2 = {
        labels: [],
        datasets: [
          {
            label: "จำนวน",
            data: [],
            backgroundColor: [
              "#050C9Caa",
              "#3572EFaa",
              "#3ABEF9aa",
              "#A7E6FFaa",
            ],
            borderColor: ["#050C9C", "#3572EF", "#3ABEF9", "#A7E6FF"],
            borderWidth: 1,
          },
        ],
      };
      for (let i = 0; i < res.data.data.length; i++) {
        if (res.data.data[i].last?.content && i < 2) {
          temp[i].last.content = JSON.parse(res.data.data[i].last?.content);
          let FirstImg = null;
          let FirstText = null;
          for (let j = 0; j < temp[i].last.content?.html?.length; j++) {
            for (let k = 0; k < temp[i].last.content?.html[j].length; k++) {
              if (
                FirstImg == null &&
                temp[i].last.content?.html[j][k].type == "image"
              ) {
                FirstImg = temp[i].last.content?.html[j][k].value;
              } else if (
                FirstText == null &&
                temp[i].last.content?.html[j][k].type == "text"
              ) {
                FirstText = temp[i].last.content?.html[j][k].value;
              }
              if (FirstImg != null && FirstText != null) {
                break;
              }
            }
            if (FirstImg != null && FirstText != null) {
              break;
            }
          }
          temp[i].last.content.img = FirstImg;
          temp[i].last.content.text = FirstText;
        }
        if (i == 2) {
          for (let j = 0; j < res.data.data[i].economy_label.length; j++) {
            tempDataset.labels.push(
              res.data.data[i].economy_label[j].economy_label
            );
            tempDataset.datasets[0].data.push(
              res.data.data[i].economy_label[j].count_economy_label
            );
          }
        }
        if (i == 3) {
          for (let j = 0; j < res.data.data[i].product_type.length; j++) {
            tempDataset2.labels.push(
              res.data.data[i].product_type[j].product_type_name
            );
            tempDataset2.datasets[0].data.push(
              res.data.data[i].product_type[j].count_product_type
            );
          }
        }
      }
      setseries(tempDataset);
      setseries2(tempDataset2);
      // setDashboardData(temp);
    }
  };

  const slide = [
    "/img/สไลด์-1.jpg",
    "/img/สไลด์-2.jpg",
    "/img/สไลด์-3.jpg",
    "/img/สไลด์-4.jpg",
    "/img/สไลด์-5.jpg",
    "/img/สไลด์-6.jpg",
    "/img/สไลด์-7.jpg",
  ];
  const ExKnowledge = [
    {
      title: "Circular Design Tag",
      img: "/img/ex1.jpg",
      path: "/knowledge/15",
    },
    // {
    //   title: "อัตลักษณ์ลวดลายผ้าหมี่ขิดจังหวัดอุดรธานี",
    //   img: "/img/ex2.jpg",
    //   path: "/knowledge/55",
    // },
  ];
  
  const Chart = () => {
    return (
      <div className="flex flex-col gap-3 w-full">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 w-full">
          <div className=" flex-col items-center h-[250px] hidden sm:flex">
            {series ? (
              <Pie
                data={series}
                options={{
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      align: "end",
                      position: "left",
                      labels:{
                        font:{
                          family:'Kanit'
                        }
                      }
                    },
                  },
                }}
              />
            ) : null}
          </div>
          <div className=" flex-col items-center h-[250px] sm:hidden flex">
            {series ? (
              <Pie
                data={series}
                options={{
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      align: "start",
                      position: "bottom",
                      labels:{
                        font:{
                          family:'Kanit'
                        }
                      }
                    },
                  },
                }}
              />
            ) : null}
          </div>
          <div className="hidden sm:flex flex-col items-center h-[250px]">
            {series ? (
              <Pie
                data={series2}
                options={{
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      align: "end",
                      position: "right",
                      labels:{
                        font:{
                          family:'Kanit'
                        }
                      }
                    },
                  },
                }}
              />
            ) : null}
          </div>
          <div className="sm:hidden flex flex-col items-center h-[210px]">
            {series ? (
              <Pie
                data={series2}
                options={{
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      align: "start",
                      position: "bottom",
                      labels:{
                        font:{
                          family:'Kanit'
                        }
                      }
                    },
                  },
                }}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="fade_In">
      <CustomHeader />
      <div className="flex flex-row items-center gap-4  pt-[180px] ">
        <div className="font_Kanit  absolute left-[10vw]">
          <p className="font-medium text-[20px] text-[#B36427]">
            ผลิตภัณท์ท้องถิ่น
          </p>
          <p className="font-bold text-[32px] md:text-[64px]">
            CIRCULAR DESIGN
          </p>
        </div>
        <img src="/img/bgGreen.png" className="w-full object-contain" />
      </div>
      <div className="px-[10vw] py-[24px] flex flex-col items-center gap-8 ">
        <div className="w-80 md:w-[700px] md:h-[500px]">
          <Carousel autoPlay showThumbs={false} showStatus={false} infiniteLoop>
            {slide.map((item, i) => {
              return (
                <img
                  key={i}
                  alt="icon"
                  src={item}
                  className="object-cover rounded-2xl md:h-[500px]"
                />
              );
            })}
          </Carousel>
        </div>
        <div>
          <a
            href={
              "https://drive.google.com/file/d/1VoEA63GgnZNwYaZbIcWjcPe7PHKYDSFI/view"
            }
            target="_blank"
            className="flex flex-row items-center gap-5 text-[#B36427] font_Kanit font-bold"
          >
            <img src="/img/icon_news.png" className="w-[40px] object-contain" />
            <p>ดาวโหลดไฟล์ คู่มือการประเมิน</p>
          </a>
        </div>
        <div className="flex flex-col gap-2 items-center">
          <p className="indent-8">
            ศูนย์สร้างสรรค์และออกแบบสิ่งทอ (FTCDC) มหาวิทยาลัยราชภัฏอุดรธานี
            ได้ริเริ่มจัดทำโครงการประเมินรับรองผลิตภัณฑ์ชุมชนตามมาตรฐานฉลากเซอคูล่าร์ดีไซน์
            (Circular design)
            เพื่อรองรับกับความต้องการของตลาดผ้าทอชุมชนสู่การพัฒนาแบบเศรษฐกิจหมุนเวียน
            (Circular Economy)
            โดยสามารถใช้ประโยชน์ทรัพยากรวัสดุที่อยู่ภายในระบบให้มีคุณภาพ
            และคุณค่าสูงสุด (Maximize Economic Value)
            หมุนเวียนเป็นวงจรต่อเนื่องเพื่อจะไม่มีของเสีย (Zero Waste to
            Landfill) หรือมีของเสียน้อยที่สุดในระบบนิเวศ
          </p>
          <p className="indent-8">
            ฉลาก Circular design
            รับรองโดยศูนย์ปฏิบัติการทดสอบวิเคราะห์ผ้าและสิ่งทอ
            ศูนย์ออกแบบสร้างสรรค์ผ้าและสิ่งทอ (FTCDC) มหาวิทยาลัยราชภัฏอุดรธานี
            และระยะเวลาการอนุญาตให้ใช้ฉลากเซอร์คูล่าห์ดีไซน์ (circular design) 1
            ปี
            นับตั้งแต่วันที่รับรองผลิตภัณฑ์นั้นและจะได้รับพิจารณาต่อฉลากต่อเนื่องติดต่อกันไม่เกิน
            3 ปี
          </p>
          <p className="font-bold">QR ลงทะเบียน</p>
          <img
            src="/img/QRcodeRegister.png"
            className="h-[200px] object-contain"
          />
        </div>
        {Chart()}
        <div className="flex flex-col md:flex-row gap-4 justify-between items-center w-full">
          <p className="font_Kanit text-[22px] md:text-[36px] font-bold text-[#B36427] ">
            ผลิตภัณท์ทั้งหมด{" "}
            {ProductCircular?.count > 0
              ? ProductCircular?.count + " รายการ"
              : null}
            {/* 496 รายการ */}
          </p>
          <div className="flex-1"/>
          <div className="self-center w-44">
            <CustomInputProduct
              type="select"
              value={year}
              data={typeYear}
              placeHolder="เลือกปี"
              onChange={(item) => {
                setyear(item);
              }}
            />
          </div>
          <CustomInput
            value={searchValue}
            onChange={(v) => setsearchValue(v)}
            placeHolder="ค้นหา"
            rightImg={"/img/Search.png"}
            onEnter={() => {
              callproduct();
              // setsearchValue("");
            }}
          />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mt-5 mb-5">
          {productItem?.map((item, i) => {
            return (
              <a
                href={"/circular-design/" + item.id}
                key={i}
                className="flex flex-col  items-center font_Kanit font-medium text-xl cursor-pointer  active:opacity-50 hover:opacity-80 "
              >
                <img
                  src={item.product_img ? hostImg + item.product_img : ""}
                  className=" h-60 object-cover rounded-lg  drop-shadow-md max-h-[400px]"
                />
                <p className="mt-3">{item.no ?? ""}</p>
                <p>{item.name}</p>
              </a>
            );
          })}
        </div>
        <CustomPagination
          now={nowPage}
          all={allPage}
          onChangePage={(page) => {
            setnowPage(page);
          }}
        />
        <div className="flex flex-col gap-4 justify-between items-center w-full">
          <div className="flex flex-row justify-center w-full">
            <p className="font_Kanit text-[22px] md:text-[36px] font-bold text-[#B36427] ">
              องค์ความรู้
            </p>
          </div>
          <div className="flex flex-row gap-6 items-center justify-center">
            {ExKnowledge.map((item, i) => {
              return (
                <a
                  key={i}
                  href={item.path}
                  className="flex flex-col items-center bg-white border drop-shadow-sm p-3 rounded-lg"
                >
                  <img src={item.img} className="rounded-lg h-52" />
                  <div>{item.title}</div>
                </a>
              );
            })}
          </div>
          <CustomButton
            txt={"อ่านเพิ่มเติม"}
            onClick={() => {
              router("/knowledge");
            }}
          />
        </div>
      </div>
      <CustomBottom />
    </div>
  );
}
